import { z } from 'zod';
/**
 * Wire-level identity of a participant on a channel. This is NOT our internal
 * Contact — identity resolution happens later. The channel layer reports what
 * the provider gave it; `channelNativeId` is whatever uniquely identifies the
 * party within that channel (email address, phone, IG user id, etc).
 */
export const SenderIdentitySchema = z.object({
    channelNativeId: z.string().min(1),
    email: z.string().email().nullable(),
    displayName: z.string().nullable(),
    phoneE164: z
        .string()
        .regex(/^\+[1-9]\d{1,14}$/, 'must be E.164 formatted')
        .nullable(),
});
//# sourceMappingURL=sender.js.map